/**
 * Helper function for the animation of numbers.
 * Counts down/up a number and calls a callback on each animation frame
 * @param {function(number)} callback callback for each animation frame
 * @param {number} from start value of the counter
 * @param {number} to end value of the counter
 * @param {number} duration animation duration in miliseconds
 */
const animateNumber = (callback, from, to, duration) => {
  let start = null,
    animate = timestamp => {
      start = start || timestamp;
      let progress = Math.min((timestamp - start) / duration, 1);
      callback(progress * (to - from) + from);
      if (progress < 1) {
        window.requestAnimationFrame(animate);
      } else {
        if (typeof done === 'function') {
          done();
        }
      }
    };
  window.requestAnimationFrame(animate);
};
export const animatePriceField = (field, fieldValue, decimals = true) => {
  const decimalNumber = decimals ? 2 : 0;
  const numericFieldValue = parseFloat(fieldValue);

  // If fieldValue is invalid, don't animate
  if (isNaN(numericFieldValue)) {
    return;
  }

  const cleanedHTML = field.innerHTML.replace('&euro;', '').replace('€', '').replace(',', '.').trim();
  const parsedValue = parseFloat(cleanedHTML);
  const startValue =
    field.innerHTML.trim() === '- €' || field.innerHTML.trim() === '-' || !cleanedHTML || isNaN(parsedValue)
      ? numericFieldValue + Math.floor(Math.random() * 31) + 50
      : parseFloat(parsedValue.toFixed(decimalNumber));

  animateNumber(
    value => {
      if (document.documentElement.lang === 'en') {
        field.innerHTML = '&euro;' + value.toLocaleString('en-US', { minimumFractionDigits: decimals ? 2 : 0, maximumFractionDigits: decimals ? 2 : 0 });
      } else {
        field.innerHTML = value.toLocaleString('de-DE', { minimumFractionDigits: decimals ? 2 : 0, maximumFractionDigits: decimals ? 2 : 0 }) + ' &euro;';
      }
    },
    startValue,
    numericFieldValue,
    750
  );
};
export default animateNumber;
